export default class Events {

	static init() {
		EventsComponent.attachEvents();
	}

	attachEvents() {
		EventsComponent.onEventDropdownChange();
		EventsComponent.onViewMore();
	}

	onEventDropdownChange() {
		$(document).on('change', '.js-events-dropdown', function(e) {
			e.preventDefault();
			var selectedMonth = this.value,
				$tabsContainer = $(this).closest('.tabs-container');

			$('[href="#'+ selectedMonth +'"]').trigger('click');
		});
	}

	getChildElementsLength(value) {
		return value.length;
	}

	onViewMore() {
		$(document).on('click', '#view-more', function(e) {
			e.preventDefault();

			var settings = {
				eventsToShow: 8,
				viewMoreText: 'view more',
				viewLessText: 'view less'
			},
				events = $(this).closest('.tab-content').find('.is-hidden'),
				target = $(this);
			let eventsLength = EventsComponent.getChildElementsLength(events);


			if (eventsLength == 0) {
				var display = $(this).closest('.tab-content').find('.is-visible').fadeOut(300, function() {
					$(this).toggleClass('is-visible is-hidden');
					target.text(settings.viewMoreText);
				});


			} else {
				$(this).text(settings.viewMoreText);
				var display = $(this).closest('.tab-content').find('.is-hidden').slice(0,settings.eventsToShow);
				display.fadeIn(300, function() {
					$(this).toggleClass('is-hidden is-visible');
				}).promise().done(function() {
					if (EventsComponent.getChildElementsLength($(this).closest('.tab-content').find('.is-hidden')) != settings.eventsToShow) {
						target.text(settings.viewLessText);
					}
				});
			}

		});
	}
}

const EventsComponent = new Events;